<template>
	<div ref="idPan">
		<div ref="idListPan" style="float:left; width:98%; margin-left:1%; height:550px; padding-bottom:10px; border:1px solid #bbbbbb; overflow-y:scroll;">
			<div class="DetPan" v-for="(curItem, index) in detList" :index="index" style="margin-top:20px;">
				<div class="Cont" style="width:60%;">{{getLangText("订单号")+": "+curItem.caiLocalOrderno}}</div>
				<div class="Cont" style="width:36%;">{{getLangText("时间")+": "+curItem.caiLocalDt}}</div>

				<div class="Cont" style="width:60%;">{{getLangText("类型")+": "+curItem.caiType_name}}</div>
				<div class="Cont" style="width:36%;">{{getLangText("状态")+": "+curItem.caiResult_name}}</div>

				<img class="CImg" style="margin-left:20px;" :src="curItem.caiImg1" v-if="img1Flag">
				<img class="CImg" style="margin-left:40px;" :src="curItem.caiImg2" v-if="img2Flag">
				<img class="CImg" style="margin-left:40px;" :src="curItem.caiImg5" v-if="img5Flag">
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'aiDetail',
	components:{
	},
	data () {
		return {
			cpLocalOrderno: "",
			img1Flag: 0,
			img2Flag: 0,
			img5Flag: 0,
			detList:[],
		}
	},
	mounted: function(){
		this.cpLocalOrderno = this.$route.query.cpLocalOrderno;

		this.getDetaiList();
	},
	computed:{

	},
	methods:{
		onResize: function( ){

			this.childResize( this );
		},

		getDetaiList: function(){
			let body={ 	caiLocalOrderno: this.cpLocalOrderno };
			this.doTrade( "POST", ServAddr+"/api/rec/aiIntfQry", this.getDetaiListOK, true, body, null );
		},
		getDetaiListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			this.detList = res.body.body.list;
			for( let i=0; i<this.detList.length; i++ )
			{
				this.detList[i].caiType_name = this.getListTextByValue( this.aiTypes, this.detList[i].caiType );
				this.detList[i].caiResult_name = this.getListTextByValue( this.aiResults, this.detList[i].caiResult );
				if( this.detList[i].caiImg1.indexOf("http")==0 ) this.img1Flag = 1;
				if( this.detList[i].caiImg2.indexOf("http")==0 ) this.img2Flag = 1;
				if( this.detList[i].caiImg5.indexOf("http")==0 ) this.img5Flag = 1;
			}
		},
	}
}

</script>

<style scoped>

.DetPan{ float:left; width:99%; margin-left:1%; border:0px solid #bbbbbb; padding-bottom:10px; }
.DetPan .Cont{ float:left; height:30px; line-height:30px; padding-left:10px; padding-right:10px; margin-left:10px; border:0px solid red; }
.DetPan .CImg{ float:left; width:200px; height:200px; border:0px solid red; }

</style>



// WEBPACK FOOTER //
// aiDetail.vue?5e3a227e